import { Theme, useTheme } from "@mui/system";

export function getEditorHighlightColor(theme: Theme): string {
  return theme?.palette?.primary?.editorHighlightColor || "#E040FB";
}

export function useEditorHighlightColor(): string {
  const theme = useTheme();
  return getEditorHighlightColor(theme);
}
